/**
 * EL CUMPLIMIENTO DE LAS REGLAS V2 POR ARGY, EN FRACCIONES (PROTOCOLOS-V2-T2 parte B).
 *
 * DE DONDE SALE. Regla 6 de las Reglas v2 (COORDINATION seccion 12, Josse D-22): lo que
 * cuenta la base se ve sin que nadie lo pida. nexo_private.v_cumplimiento_argys cuenta por
 * Argy, en los ultimos 7 dias, cuantos cierres traen las claves, cuantos WIP traen
 * checklist_leida y cuantos DONE traen nodos. A la sirve la vista tal cual en
 * GET /api/v1/salud/cumplimiento-argys (nexo-api PR 278).
 *
 * LA REGLA:
 *   - una fraccion por regla: cumplen / total
 *   - 0 de n es rojo, n de n es verde, en medio es ambar
 *   - 0 de 0 NO es cero ni verde: es "sin eventos" (no hubo nada que medir)
 *   - los Argys salen de la respuesta, nunca de una lista escrita aqui
 *   - la lectura tolera camelCase (DTO) y snake_case (vista)
 *
 * Sin DOM: lo prueba scripts/check-salud-cumplimiento.mjs.
 */

const pick = (o, ...claves) => {
  for (const k of claves) if (o && o[k] !== undefined && o[k] !== null) return o[k];
  return null;
};
const entero = (v) => {
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 ? Math.trunc(n) : 0;
};

/** Una fraccion con su estado: 'verde' | 'ambar' | 'rojo' | 'sin-eventos'. */
export function fraccion(cumplen, total) {
  const t = entero(total);
  const c = Math.min(entero(cumplen), t);
  const estado = t === 0 ? 'sin-eventos' : c === t ? 'verde' : c === 0 ? 'rojo' : 'ambar';
  return { cumplen: c, total: t, texto: `${c}/${t}`, estado };
}

/** Las filas del endpoint, normalizadas y ordenadas por nombre. Nunca lanza. */
export function leerCumplimiento(filas) {
  const lista = Array.isArray(filas) ? filas : [];
  return lista
    .map((f) => ({
      argy: String(pick(f, 'argy', 'Argy') ?? '').trim(),
      cierres: fraccion(pick(f, 'cierresConTresClaves', 'cierres_con_tres_claves', 'CierresConTresClaves'), pick(f, 'cierres', 'Cierres')),
      wips: fraccion(pick(f, 'wipsConChecklistLeida', 'wips_con_checklist_leida', 'WipsConChecklistLeida'), pick(f, 'wips', 'Wips')),
      dones: fraccion(pick(f, 'donesConNodos', 'dones_con_nodos', 'DonesConNodos'), pick(f, 'dones', 'Dones')),
      ultimoEvento: pick(f, 'ultimoEvento', 'ultimo_evento', 'UltimoEvento')
    }))
    .filter((f) => f.argy !== '')
    .sort((a, b) => a.argy.localeCompare(b.argy, 'es'));
}
